import { createSelector } from 'reselect';

const selectScopesDomain = state => state.Scopes;

// Basic selectors
const makeSelectScopes = () =>
  createSelector(selectScopesDomain, substate => substate);

const makeSelectScopesList = () =>
  createSelector(selectScopesDomain, substate => substate.scopes);

const makeSelectScopesLoading = () =>
  createSelector(selectScopesDomain, substate => substate.loading);

const makeSelectScopesError = () =>
  createSelector(selectScopesDomain, substate => substate.error);

const makeSelectScopesLastUpdated = () =>
  createSelector(selectScopesDomain, substate => substate.lastUpdated);

// Utility selectors
const makeSelectScopeById = (scopeId) =>
  createSelector(
    selectScopesDomain,
    substate => substate.scopes.find(scope => scope.id === scopeId)
  );

const makeSelectScopesByCategory = (category) =>
  createSelector(
    selectScopesDomain,
    substate => substate.scopes.filter(scope => scope.category === category)
  );

const makeSelectScopesByResource = (resource) =>
  createSelector(
    selectScopesDomain,
    substate => substate.scopes.filter(scope => scope.resource === resource)
  );

const makeSelectScopesByAction = (action) =>
  createSelector(
    selectScopesDomain,
    substate => substate.scopes.filter(scope => scope.action === action)
  );

const makeSelectScopesSearch = (searchTerm) =>
  createSelector(
    selectScopesDomain,
    substate => {
      if (!searchTerm) return substate.scopes;
      const term = searchTerm.toLowerCase();
      return substate.scopes.filter(scope =>
        scope.name.toLowerCase().includes(term) ||
        scope.description.toLowerCase().includes(term) ||
        scope.resource.toLowerCase().includes(term) ||
        scope.action.toLowerCase().includes(term)
      );
    }
  );

const makeSelectScopesGroupedByResource = () =>
  createSelector(
    selectScopesDomain,
    substate => {
      const grouped = {};
      substate.scopes.forEach(scope => {
        if (!grouped[scope.resource]) {
          grouped[scope.resource] = [];
        }
        grouped[scope.resource].push(scope);
      });
      return grouped;
    }
  );

const makeSelectScopesGroupedByCategory = () =>
  createSelector(
    selectScopesDomain,
    substate => {
      const grouped = {};
      substate.scopes.forEach(scope => {
        if (!grouped[scope.category]) {
          grouped[scope.category] = [];
        }
        grouped[scope.category].push(scope);
      });
      return grouped;
    }
  );

export default makeSelectScopes;
export {
  makeSelectScopes,
  makeSelectScopesList,
  makeSelectScopesLoading,
  makeSelectScopesError,
  makeSelectScopesLastUpdated,
  makeSelectScopeById,
  makeSelectScopesByCategory,
  makeSelectScopesByResource,
  makeSelectScopesByAction,
  makeSelectScopesSearch,
  makeSelectScopesGroupedByResource,
  makeSelectScopesGroupedByCategory,
};
